import client from './client';

export const fetchUser = async () => {
  try {
    const user = await client.get('');

    return user.data;
  } catch (e) {
    return e
  }
}
